// import React from 'react';
// import { FaCheckCircle, FaCircle } from 'react-icons/fa';
// import './OrderTimeline.css';

// const steps = [
//   { key: 'placed', label: 'Order Placed', timeKey: 'created_at' },
//   { key: 'accepted', label: 'Order Accepted', timeKey: 'accepted_at' },
//   { key: 'arrived', label: 'Servitor Arrived', timeKey: 'in_progress_at' },
//   { key: 'completed', label: 'Order Complete', timeKey: 'completed_at' },
// ];

// export default function OrderTimeline({ order }) {
//   return (
//     <div className="OrderTimeline-container">
//       {steps.map((step, i) => {
//         const timestamp = order[step.timeKey];
//         const done = Boolean(timestamp);
//         return (
//           <div key={step.key} className="OrderTimeline-step">
//             <div className={`OrderTimeline-icon ${done ? 'done' : ''}`}>
//               {done ? <FaCheckCircle /> : <FaCircle />}
//             </div>
//             <div className="OrderTimeline-label">{step.label}</div>
//             <div className="OrderTimeline-time">
//               {done
//                 ? new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
//                 : '—'}
//             </div>
//             {i < steps.length - 1 && (
//               <div className={`OrderTimeline-bar ${done ? 'done' : ''}`} />
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// }












// import React from 'react';
// import { FaCheckCircle, FaCircle, FaClipboardCheck, FaUserTie,FaUserCheck, FaFlagCheckered,FaGift } from 'react-icons/fa';
// import './OrderTimeline.css';

// const steps = [
//   { key: 'placed', label: 'Order Placed', timeKey: 'created_at', color: '#3B82F6' },
//   { key: 'accepted', label: 'Order Accepted', timeKey: 'accepted_at', color: '#F59E0B' },
//   { key: 'arrived', label: 'Servitor Arrived', timeKey: 'in_progress_at', color: '#8B5CF6' },
//   { key: 'completed', label: 'Order Complete', timeKey: 'completed_at', color: '#10B981' },
// ];

// export default function OrderTimeline({ order }) {
//   return (
//     <div className="OrderTimeline-wrapper">
//       <h3 className="OrderTimeline-title">Order Progress</h3>
//       <div className="OrderTimeline-container">
//         {/* <div className="OrderTimeline-background-line"></div> */}
//         {steps.map((step, i) => {
//           const timestamp = order[step.timeKey];
//           const done = Boolean(timestamp);
//           return (
//             <div key={step.key} className="OrderTimeline-step">
//               <div 
//                 className={`OrderTimeline-icon ${done ? 'done' : ''} ${step.key}`}
//                 style={done ? { '--step-color': step.color } : {}}
//               >
//                 <div className="OrderTimeline-icon-inner">
//                   {done ? <FaCheckCircle /> : <FaCircle />}
//                 </div>
//               </div>
//               <div className="OrderTimeline-content">
//                 <div className="OrderTimeline-label">{step.label}</div>
//                 <div className="OrderTimeline-time">
//                   {done
//                     ? new Date(timestamp).toLocaleString([], { 
//                         month: 'numeric', 
//                         day: 'numeric', 
//                         hour: '2-digit', 
//                         minute: '2-digit' 
//                       })
//                     : '--'}
//                 </div>
//               </div>
//               {i < steps.length - 1 && (
//                 <div className={`OrderTimeline-connector ${done && order[steps[i + 1].timeKey] ? 'done' : ''}`} />
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }






import React from 'react';
import {
  FaCheckCircle,
  // FaCircle,
  FaUserTie,
  FaUserCheck,
  FaFlagCheckered,
  FaRegClock,
  FaTimesCircle,
  FaUserSlash
} from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './OrderTimeline.css';

export default function OrderTimeline({ order }) {
  const { t } = useTranslation();
  
  // always start with "placed"
  const sequence = [
    {
      key: 'placed',
      // label: 'Order Placed',
      label: t('orderTimeline.steps.placed'),
      timeKey: 'created_at',
      color: '#3B82F6',
      Icon: FaCheckCircle,
      done: true,
    }
  ];

  const {
    accepted_at,
    in_progress_at,
    completed_at,
    status,
    // updated_at
  } = order;

  // helper to push a step
  const pushStep = ({ key, label, timeKey, color, Icon, done }) =>
    sequence.push({ key, label: t(`orderTimeline.steps.${label}`), timeKey, color, Icon, done: Boolean(order[timeKey]) });

  // 1) if we ever had an acceptance timestamp
  if (accepted_at) {
    pushStep({
      key: 'accepted',
      // label: 'Order Accepted',
      label: 'accepted',
      timeKey: 'accepted_at',
      color: '#F59E0B',
      Icon: FaUserTie,
    });
  }

  // 2) if we ever started
  if (in_progress_at) {
    pushStep({
      key: 'arrived',
      // label: 'In Progress',
      label: 'arrived',
      timeKey: 'in_progress_at',
      color: '#8B5CF6',
      Icon: FaUserCheck,
    });
  }

  // 3) if completed
  if (completed_at) {
    pushStep({
      key: 'completed',
      // label: 'Order Complete',
      label: 'completed',
      timeKey: 'completed_at',
      color: '#10B981',
      Icon: FaFlagCheckered,
    });
  }

  // 4) handle final “error” statuses
  if (status === 'Deadline-Timeout') {
    pushStep({
      key: 'timeout',
      // label: 'Deadline Timeout',
      label: 'timeout',
      timeKey: 'updated_at',
      color: '#EF4444',
      Icon: FaRegClock,
      done: true
    });
  } else if (status === 'Cancelled') {
    pushStep({
      key: 'cancelled',
      // label: 'Cancelled by User',
      label: 'cancelled',
      timeKey: 'updated_at',
      color: '#EF4444',
      Icon: FaTimesCircle,
      done: true
    });
  } else if (status === 'Cancelled by Servitor') {
    pushStep({
      key: 'cancelled-servitor',
      // label: 'Cancelled by Servitor',
      label: 'cancelled-servitor',
      timeKey: 'updated_at',
      color: '#EF4444',
      Icon: FaUserSlash,
      done: true
    });
  }

  return (
    <div className="OrderTimeline-wrapper">
      {/* <h3 className="OrderTimeline-title">Order Progress</h3> */}
      <h3 className="OrderTimeline-title">{t('orderTimeline.title')}</h3>
      <div className="OrderTimeline-container">
        {/* background line */}
        {/* <div className="OrderTimeline-background-line" /> */}
        {sequence.map((step, i) => {
          const { key, label, timeKey, color, Icon, done } = step;
          const timestamp = order[timeKey];
          const isLast = i === sequence.length - 1;
          // connector is “done” if both this and next are done and color isn’t red-error
          const next = sequence[i + 1];
          const connDone = next && done && next.done && color !== '#EF4444';
          return (
            <div key={key} className="OrderTimeline-step">
              <div
                className={`OrderTimeline-icon ${done ? 'done' : ''} ${key}`}
                style={done ? { '--step-color': color } : {}}
              >
                <Icon className="OrderTimeline-icon-inner" />
              </div>
              <div className="OrderTimeline-content">
                <div className="OrderTimeline-label">{label}</div>
                <div className="OrderTimeline-time">
                  {done
                    ? new Date(timestamp).toLocaleString([], {
                        month: 'numeric',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })
                    : '--'}
                </div>
              </div>
              {!isLast && (
                <div
                  className={`OrderTimeline-connector ${connDone ? 'done' : ''} ${
                    color === '#EF4444' ? 'error' : ''
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
